import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getUserProfessionalConnections } from "../services/professionalConnections.service";
import { userKeys } from "../queryKeys";
import { ProfessionalConnectionsResponse } from "../types/professionalConnections.types";

export const useUserProfessionalConnections = (userId: string | null) => {
  const { i18n } = useTranslation();

  return useQuery<ProfessionalConnectionsResponse["data"], Error>({
    queryKey: [...userKeys.professionalConnections(userId!), i18n.language],
    queryFn: async () => {
      const response = await getUserProfessionalConnections(userId!);
      return response.data;
    },
    enabled: !!userId,
  });
};
